import { visit } from 'graphql';
import type { DocumentNode } from 'graphql';

import { COST_KEYS } from '../../../../libs/auth/costs';

const SUFFIX = 'NoCost';

// The document with every cost field gone, in its fragments too, which are renamed so they never share a name with
// the ones of the queries. A subscription message is the payload of the mutation that fed it and one message goes to
// every subscriber, so neither document may select a cost; the server strips queries and mutations per caller.
export const withoutCostFields = (document: DocumentNode): DocumentNode =>
  visit(document, {
    Field: {
      leave: (node) => (COST_KEYS.has(node.name.value) || node.selectionSet?.selections.length === 0 ? null : undefined)
    },
    FragmentDefinition: {
      enter: (node) => ({ ...node, name: { ...node.name, value: `${node.name.value}${SUFFIX}` } })
    },
    FragmentSpread: {
      enter: (node) => ({ ...node, name: { ...node.name, value: `${node.name.value}${SUFFIX}` } })
    }
  });

export const costFreeFragmentName = (name: string): string => `${name}${SUFFIX}`;
